export default __webpack_public_path__ + "static/media/modal4.83904c67.jpg";